export default __webpack_public_path__ + "static/media/LocationMarkerSmall.23250459.svg";